import { render, staticRenderFns } from "./PaymentCheckoutHeader.vue?vue&type=template&id=13d2c399"
import script from "./PaymentCheckoutHeader.vue?vue&type=script&lang=js"
export * from "./PaymentCheckoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports